import React, { Component } from 'react';
import { topicJuniorAccountantImgs } from '../../images/topicImg';
export default class StyleThreeCurriculum extends Component {
  static propTypes = {};

  render() {
    const { itemsData } = this.props;
    return (
      <div
        className="style-three-style-three-curriculum"
        style={{ backgroundImage: `url(${itemsData.backgroundImg})` }}
      >
        <div className="inner">
          <h1 className="title" style={{ backgroundImage: `url(${itemsData.url})` }}>
            <p className="p1">{itemsData.title}</p>
            <p className="p2">{itemsData.subtitle}</p>
          </h1>
          <div className="classes">
            {itemsData.list.map((item, key) => (
              <div key={key} className="class">
                <div className="top-nav">
                  <img src={item.bgImg} alt="" />
                  <p>{item.Name}</p>
                </div>
                <div className="suitsCrowd">
                  {key === 0 && <div className="type">适合人群</div>}
                  {item.suitsCrowd.map((it, k) => (
                    <p key={k} className="crowd">
                      <img src={topicJuniorAccountantImgs.course_point} alt="" />
                      {it.crowd}
                    </p>
                  ))}
                </div>
                <div className="courseContent">
                  {key === 0 && <div className="type">课程内容</div>}
                  <div className="content">
                    {item.courseContent[0] && (
                      <div className="all">
                        <div className="top">
                          {/* <p>{item.courseContent[0].}</p> */}
                        </div>
                        <div className="bottom"></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/style-three/StyleThreeCurriculum.js